import NotesPanel from "@/components/NotesPanel";
import { StickyNote } from "lucide-react";

export default function NotesPage() {
  return (
    <div className="space-y-6 fade-up max-w-3xl">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600 mb-1">Field Notes</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-heading flex items-center gap-2">
          <StickyNote className="h-8 w-8 text-lime-500" /> Notes
        </h1>
        <p className="text-slate-500 mt-1">Log timestamped notes, dictate with voice-to-text, assign to crew, and turn any note into a job.</p>
      </div>
      <NotesPanel />
    </div>
  );
}
